import React, { useEffect } from 'react';
import { Modal as BlueberryModal } from '@neshane/blueberry';
import './Modal.css';

function Modal({ isOpen, onClose, title, subtitle, children, footer, size = 'medium', iconName = 'circle-information', iconVariant = 'info' }) {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    return (
        <BlueberryModal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            subtitle={subtitle}
            iconName={iconName}
            iconVariant={iconVariant}
            className={`blueberry-modal modal-${size}`}
            actions={footer}
        >
            {children}
        </BlueberryModal>
    );
}

export default Modal;